const getCookie = (name: string) => {
  if (!name || typeof document === 'undefined') {
    return null
  }

  const encodedName = `${encodeURIComponent(name)}=`
  const cookie = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(encodedName))

  if (!cookie) {
    return null
  }

  const cookieValue = cookie.slice(encodedName.length)
  try {
    return decodeURIComponent(cookieValue)
  } catch {
    return cookieValue
  }
}

export { getCookie }
